import ThumbUpAltIcon from "@material-ui/icons/ThumbUpAlt";
import React, { useState } from "react";
import {
	Button,
	Confirm,
	useNotify,
	useRefresh,
	useTranslate,
	useUnselectAll,
	useUpdateMany,
} from "react-admin";

const ApproveButton = ({ selectedIds }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const refresh = useRefresh();
	const unselectAll = useUnselectAll();
	const [isOpen, setIsOpen] = useState(false);
	const status = "approved";
	const [updateMany, { loading }] = useUpdateMany(
		"bookmaker-approvals",
		selectedIds,
		{ status },
		{
			onSuccess: () => {
				notify(translate(`resources.bookmaker-approvals.messages.${status}`));
				unselectAll("bookmaker-approvals");
				refresh();
				handleClose();
			},
			onError: () => {
				notify(translate("resources.bookmaker-approvals.messages.error"));
			},
		}
	);

	const handleClose = () => setIsOpen(false);
	const handleOpen = () => setIsOpen(true);

	return (
		<>
			<Confirm
				isOpen={isOpen}
				loading={loading}
				title={translate("resources.bookmaker-approvals.actions.approve.title")}
				content={translate(
					"resources.bookmaker-approvals.actions.approve.content"
				)}
				onConfirm={updateMany}
				onClose={handleClose}
			/>
			<Button
				onClick={handleOpen}
				label={translate("resources.user-payments.buttons.approve")}
			>
				<ThumbUpAltIcon />
			</Button>
		</>
	);
};

export default ApproveButton;
